import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Container, Form, Table } from 'react-bootstrap';
import { faRotateLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Loading } from '../../../components/Loading/Loading';
import { useMutationData } from '../../../hooks/useMutationData';
import { useGetData } from '../../../hooks/useGetData';

/**
 * RolEditarScreen
 * @description: Pantalla que edita la lista de permisos para un rol específico
 * @date 16/10/2023.
 * @returns JSX del Screen.
 */
export const RolEditarScreen = () => {
  const navigate = useNavigate();
  const { rolId } = useParams<{ rolId: string }>();

  useEffect(() => {
    if (!rolId) {
      console.error('No se ha proporcionado un rolId válido');
    } else {
      console.log('ID del rol a editar:', rolId);
    }
  }, [rolId]);

  const queryPermisosDelRol = useGetData<{ id: number }[]>({
    url: rolId ? `/rol/${rolId}/permisos` : '',
    name: ['rol-permisos', rolId || ''],
  });

  const queryPermisos = useGetData<{ id: number, nombre: string }[]>({
    url: '/permiso',
    name: ['permiso'],
  });

  const mutateRol = useMutationData({
    url: '/rol',
    reload: ['rol'],
  });

  const mutatePermiso = useMutationData({
    url: `/rol/${rolId}/permiso`,
    reload: ['permiso'],
  });
  
  // Para DELETE
  const handleTogglePermission = async (permisoId: number, isActive: boolean) => {
    try {
      if (isActive) {
        await mutatePermiso.mutateAsync({
          data: { permiso_id: permisoId },
          tipo: 'post',
        });
      } else {
        await mutatePermiso.mutateAsync({
          tipo: 'delete',
          id: permisoId,
        });
      }
      
    queryPermisosDelRol.refetch();
  } catch (error) {
    console.error("Error al modificar permisos:", error);
  }
};


  if (queryPermisos.isLoading || queryPermisosDelRol.isLoading) {
    return <Loading />;
  }

  return (
    <Container className="p-4">
      <div className="mb-6 flex justify-between items-center">
        <h2 className="text-3xl font-semibold text-gray-800">Editar Permisos para el Rol ID: {rolId}</h2>
        <Button
          title="Regresar"
          className="bg-blue hover:bg-blue text-white"
          onClick={() => navigate('/rol')}
        >
          <FontAwesomeIcon icon={faRotateLeft} className="mr-2 text-white" /> Regresar
        </Button>
      </div>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>ID</th>
            <th>Nombre</th>
            <th>Estatus</th>
          </tr>
        </thead>
        <tbody>
          {queryPermisos.data?.map(permiso => {
            const isActive = queryPermisosDelRol.data?.some(p => p.id === permiso.id);

            return (
              <tr key={permiso.id}>
                <td>{permiso.id}</td>
                <td>{permiso.nombre}</td>
                <td>
                  <Form.Check
                    type="switch"
                    id={`permiso-switch-${permiso.id}`}
                    checked={isActive}
                    onChange={(e) => handleTogglePermission(permiso.id, e.target.checked)}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Container>
  );
};
